import { isPrerendering } from 'services/prerender'

export function getRESTBaseURL() {
  return (isPrerendering() ? (process.env.BACKEND_API_ROOT_URL || process.env.NEXT_PUBLIC_API_ROOT_URL) : process.env.NEXT_PUBLIC_API_ROOT_URL)!
}

export function getGraphQLBaseURL() {
  return getRESTBaseURL().replace('/api/v1', '/api/v2')
}

export function getWebsocketBaseURL() {
  return `${getGraphQLBaseURL().replace('/api/v2', '')}/websocket`
}
